/**
 * Indian mobile: 10 digits, first digit 6/7/8/9.
 * Optional leading 0 or +91 (with optional spaces/dashes).
 */
export const validateIndianMobile = (value) => {
  if (!value || typeof value !== 'string') {
    return { valid: false, message: 'Mobile number is required' };
  }
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) {
    return { valid: false, message: 'Mobile number is required' };
  }
  const num = digits.length === 11 && digits.startsWith('0') ? digits.slice(1) : digits.length === 12 && digits.startsWith('91') ? digits.slice(2) : digits;
  if (num.length !== 10) {
    return { valid: false, message: 'Mobile number must be 10 digits' };
  }
  if (!/^[6-9]/.test(num)) {
    return { valid: false, message: 'Mobile number must start with 6, 7, 8 or 9' };
  }
  return { valid: true };
};

/**
 * Indian postal code (pincode): exactly 6 digits.
 */
export const validateIndianPincode = (value) => {
  if (!value || typeof value !== 'string') {
    return { valid: false, message: 'Postal code is required' };
  }
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return { valid: false, message: 'Postal code is required' };
  }
  if (!/^\d{6}$/.test(trimmed)) {
    return { valid: false, message: 'Postal code must be exactly 6 digits' };
  }
  return { valid: true };
};
